{
  "title": "位置情報へのアクセスを許可しますか？",
  "body": "位置情報へのアクセスを許可すると、チェックインのために施設に到着したことを確認できます",
  "disagree": "許可しない",
  "agree": "許可する"
}
